import { Header } from '../Header/Header';
import { Footer } from '../Footer/Footer';
import { LayoutHorizontal } from '../LayoutHorizontal/LayoutHorizontal';
import './LayoutVertical.css';
import { Dispatch, SetStateAction } from 'react';

export const LayoutVertical = ({
    isInventoryOpen,
    setIsInventoryOpen,
}: {
    isInventoryOpen: boolean;
    setIsInventoryOpen: Dispatch<SetStateAction<boolean>>;
}) => {
    return (
        <div className="layout-vertical">
            <div className="layout-vertical__rest">
                <Header />
                <LayoutHorizontal isInventoryOpen={isInventoryOpen} setIsInventoryOpen={setIsInventoryOpen} />
                <Footer />
            </div>
        </div>
    );
};
